import { AEMErrorMessage } from '../../../models';

export const OffersErrorMessage: AEMErrorMessage = {
  action: {
    label: 'View All Promotions',
    url: '/mypromos/eligible',
    id: 'viewPromotionsPage'
  },
  component: 'offers',
  errorId: [
    {
      errorCode: '702'
    }
  ],
  featureTitle: '',
  errorMessageDescription:
    'Sorry, we’re currently unable to display your Promotions. Please try again later.',
  errorMessageTitle: '',
  type: 'single-error'
};
